<div>
    <div class="modal-header px-0 pb-0">
        <h4 class="modal-title" id="modal-basic-title">{{localize(langSection.RequestFormPage,
            langText.LocationSetupIncomplete)}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
    </div>
    <div class="modal-body pb-0">    
        <div>
            <span>{{localize(langSection.RequestFormPage, langText.DestinationSetupIncompleteMessage)}}</span>
            <ul>
                @if (defaultResponsibleSiteCompanyName) {
<li>{{localize(langSection.RequestFormPage, langText.DefaultResponsibleLocation)}}: <span>{{defaultResponsibleSiteCompanyName}}</span></li>
}
                @if (defaultResponsibleSitePhone) {
<li >{{localize(langSection.Term, langText.Phone)}}: <span>{{defaultResponsibleSitePhone}}</span></li>
}
                @if (defaultResponsibleSiteEmail) {
<li >{{localize(langSection.Term, langText.Email)}}: <span>{{defaultResponsibleSiteEmail}}</span></li>
}
            </ul>
        </div> 
    </div>
    <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-green" (click)="goBack()">Close</button>
    </div>
</div>